const HalfCircleTitle = () => {
  return (
    <div className="round-lg relative size-[200px] shrink-0 rounded-full border border-gray-300 bg-green-200 pb-0.5">
      <div className="absolute -bottom-0.5 w-[200px] bg-white text-center">&nbsp;</div>
    </div>
  );
};

export default HalfCircleTitle;
